module.exports = __webpack_public_path__ + "static/img/S07.2333d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S07.png
// module id = T44q
// module chunks = 7